/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: ba8cfc219d76
 */

import * as z from "zod";

export type ErrorT = { message: string };

export const ErrorT$zodSchema: z.ZodType<ErrorT> = z.object({
  message: z.string(),
});

export type ApiError = { error: ErrorT };

export const ApiError$zodSchema: z.ZodType<ApiError> = z.object({
  error: z.lazy(() => ErrorT$zodSchema),
});
